import { space } from "@rally/ui-kit/src/tokens/tokens.ts";

export const GUTTER = space[4];

export const CONTENT_HEADER_HEIGHT = 64;

export const COMPOSER_BORDER = 1;
export const COMPOSER_INSET = space[4];

export const WORDS_IN_COMPOSER = COMPOSER_BORDER + COMPOSER_INSET;

export const LANE_WIDTH = 28;

export const rowIn = (panel: number) => panel - GUTTER * 2;
